import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

import { Tooltip, LinkButton } from 'core/components';
import CompoundIcon from 'app/components/CompoundIcon';

import { MdWifiFind } from 'react-icons/md';

@inject('$discovery')
@observer
export default class DiscoveryProgressChip extends Component {
  renderMultipleDiscoveriesIcon = () => {
    const { $discovery } = this.props;
    const { activeDiscoveries } = $discovery.collection;
    return (
      <CompoundIcon
        icon={MdWifiFind}
        badgeCount={activeDiscoveries.length}
        showBadge={activeDiscoveries.length > 1}
        badgeColor="kentik"
        badgeOutlineColor="navbarBackground"
        color="white.10"
      />
    );
  };

  renderSingleDiscoveryIcon = (devicesFound) => (
    <CompoundIcon
      icon={MdWifiFind}
      iconSize={30}
      badgeCount={devicesFound > 99 ? '99+' : devicesFound}
      showBadge={devicesFound > 0}
      badgeColor="success"
      badgeOutlineColor="navbarBackground"
    />
  );

  render() {
    const { $discovery } = this.props;
    const { activeDiscoveries } = $discovery.collection;

    if (activeDiscoveries.length === 0) {
      return null;
    }

    // Handle multiple discoveries case
    if (activeDiscoveries.length > 1) {
      const tooltipContent = `${activeDiscoveries.length} discoveries to review`;
      return (
        <Tooltip content={tooltipContent}>
          <LinkButton to="/v4/nms/discovery" color="white.5" minimal icon={this.renderMultipleDiscoveriesIcon} />
        </Tooltip>
      );
    }

    // Handle single discovery case
    const model = activeDiscoveries[0];
    const { percentComplete, devicesFound } = model.status;
    const progressPercent = Math.round(percentComplete * 100);
    const tooltipContent = `Discovery in progress: ${progressPercent}% complete, ${Number(devicesFound).toLocaleString()} ${devicesFound === 1 ? 'device' : 'devices'} found`;
    const singleDiscoveryIcon = this.renderSingleDiscoveryIcon(devicesFound);

    return (
      <Tooltip content={tooltipContent}>
        <LinkButton to={`/v4/nms/discovery/${model.id}`} minimal color="white.5" icon={singleDiscoveryIcon} />
      </Tooltip>
    );
  }
}
